'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { MdOutlineFeedback } from 'react-icons/md';
import clsx from 'clsx';
import FeedbackFormDialog from './FeedbackFormDialog';

type FloatingFeedbackButtonProps = {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

const sizeClasses = {
  sm: 'min-h-9 min-w-9 p-2',
  md: 'min-h-11 min-w-11 p-3',
  lg: 'min-h-12 min-w-12 p-3.5',
};

export default function FloatingFeedbackButton({
  className,
  size = 'md',
}: FloatingFeedbackButtonProps) {
  const [open, setOpen] = useState(false);
  const tLayout = useTranslations('layout');
  const tInquiry = useTranslations('inquiry');

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={clsx('scroll-btn group', sizeClasses[size], className)}
        aria-label={tLayout('floatingFeedbackLabel')}
      >
        <span className="scroll-btn__sheen" aria-hidden />
        <MdOutlineFeedback className="scroll-btn__icon" aria-hidden />
      </button>
      <FeedbackFormDialog
        open={open}
        onClose={() => setOpen(false)}
        title={tLayout('floatingFeedbackTitle')}
        subtitle={tLayout('floatingFeedbackSubtitle')}
        closeLabel={tLayout('floatingFeedbackClose')}
        formLabels={{
          submit: tInquiry('submit'),
          name: tInquiry('nameLabel'),
          email: tInquiry('emailLabel'),
          company: tInquiry('companyLabel'),
          message: tInquiry('messageLabel'),
        }}
      />
    </>
  );
}
